import React, { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import ContentHeader from '../../../../Components/Layout/ContentHeader'
import LayoutTable from '../../../../Components/Global/LayoutTable'
import { useHistory } from 'react-router-dom'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import PreviewForm from './componets/previewForm/PreviewForm'
import {
  GET_ALL_FORMS,
  DELETE_FORM,
} from '../../../../graphql/Catalog/Forms/forms'
import ModalContent from '../../../Global/ModalContent'

const idModal = 'modalForm'

export const Forms = () => {
  const history = useHistory()

  //STATES:
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
  })
  const [total, setTotal] = useState(0)
  const [dataToTable, setDataToTable] = useState([])
  const [modalContent, setModalContent] = useState({
    title: '',
    content: null,
  })

  //QUERIES:
  const { loading, error, data } = useQuery(GET_ALL_FORMS, {
    variables: {
      searchQuery: pagePagination.searchQuery,
      limit: pagePagination.limit,
      offset: pagePagination.offset,
    },
  })

  const showModal = async ({ type, item }) => {
    try {
      if (type === 'previewForm') {
        setModalContent({
          title: `Preview - (${item?.name})`,
          content: (
            <PreviewForm
              formId={parseInt(item.id)}
              type={type}
              setModalContent={setModalContent}
              showModal={showModal}
            />
          ),
        })
      }
    } catch (error) {
      console.log({ error })
    }
  }

  const handleCloseModal = () => {
    setModalContent({ title: null, content: null })
  }

  const handleViewFields = (item) => {
    sessionStorage.setItem(
      'formSelected',
      JSON.stringify({
        name: item.name,
        description: item.description,
        diplay_name: item.diplay_name,
        display_name_plural: item?.display_name_plural,
        icon: item?.icon,
      })
    )

    history.push(`/catalog/forms/${item.id}/fields`)
  }

  //EFFECTS:
  useEffect(() => {
    if (!loading) {
      if (error)
        return toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      let list = []
      data.getAllForms.rows.map((item) => {
        return list.push({
          id: item.id,
          nombre: item.name,
          descripcion: item.description,
          'Titulo a mostrar': item.diplay_name,
          Icono: <i className={`fas fa-${item.icon}`}></i>,
          Preview: (
            <button
              type="button"
              className="btn btn-migrates"
              data-toggle="modal"
              data-target={`#${idModal}`}
              onClick={(e) => showModal({ type: 'previewForm', item })}
            >
              <i className="fab fa-wpforms"></i>
            </button>
          ),
          campos: (
            <button
              type="button"
              className="btn btn-migrates"
              onClick={() => handleViewFields(item)}
            >
              <i className="fa fa-eye"></i> ({item.FieldsOfForm.length})
            </button>
          ),
        })
      })
      setDataToTable(list)
      setTotal(data.getAllForms.count)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, data])

  return (
    <>
      <ContentHeader
        title="Formularios dinamicos"
        breadcrumb=""
        windowTitle="Formularios dinamicos"
      />
      <LayoutTable
        title="Lista de formularios"
        hideId
        data={dataToTable}
        gql={DELETE_FORM}
        requery={GET_ALL_FORMS}
        exportImportButton={false}
        totalCount={total}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        loadingData={loading}
        FilterBarPlaceholder="Buscar por nombre, descripcion, o titulo"
        hideDetails
      />

      <span
        id={`spanModal${idModal}`}
        className="btn invisible"
        data-toggle="modal"
        data-target={'#' + idModal}
        data-backdrop="static"
        data-keyboard="false"
        data-dismiss="modal"
      />

      <ModalContent
        idModal={idModal}
        title={modalContent.title}
        size="extra"
        onClose={() => handleCloseModal()}
        content={modalContent.content}
      />
    </>
  )
}

export default Forms
